import { IeLynxObject } from "../../common/models/eLynxObject";
import { RestError } from "../../services/rest-service/RestService";
import { useQuery } from "react-query";
import { IObjectPropertiesDeviceModel, IObjectPropertiesTankBatteryModel, IObjectPropertiesTankModel, IObjectPropertiesWellModel, ITagProperties } from "../../services/properties-data-service/Models";
import PropertiesDataService from "../../services/properties-data-service/PropertiesDataService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseObjectPropertiesQueryParams = {
    groupID: number, 
    eLynxObject: IeLynxObject
} & BaseUseQueryParameters<IObjectPropertiesDeviceModel |
        IObjectPropertiesTankModel |
        IObjectPropertiesTankBatteryModel |
        IObjectPropertiesWellModel | 
        ITagProperties>;


export function useObjectProperties(params: UseObjectPropertiesQueryParams) {
    return useQuery<IObjectPropertiesDeviceModel |
        IObjectPropertiesTankModel |
        IObjectPropertiesTankBatteryModel |
        IObjectPropertiesWellModel | 
        ITagProperties, RestError>(
            keys.properties(params.groupID, params.eLynxObject),
            ({ signal }) => {
                return PropertiesDataService.getPropertyData(params.groupID, params.eLynxObject, signal) as unknown as IObjectPropertiesDeviceModel |
                    IObjectPropertiesTankModel |
                    IObjectPropertiesTankBatteryModel |
                    IObjectPropertiesWellModel |
                    ITagProperties;
            },
            {
                enabled: params.enabled,
                onError: params.onError,
                onSuccess: params.onSuccess,
                refetchInterval: params.refreshSeconds ? params.refreshSeconds  * 1000 : false,
                staleTime: Infinity
            }
        );
}
